import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import Select2Multiple from 'v-select2-multiple-component';
import moment from 'moment';
import CONFIG from "@/assets/js/config.custom.js";

export default {
    name: 'studentStatementDetail',
    components: {
        MainLayout,
        Loading,
        Select2Multiple,
    },

    data() {
        return {
            statementInfo: {},
            attendedAcdYears: '',
            studentPayments: [],
            ferryPayments: [],
            lateFees: [],
            tuitionBalanceSummary: {},
            allPaymentSummary: [],
            isLoading: false,
            periodColumnName: "",
            noDataMsg: CONFIG.NO_DATA_EXIST,
            hasTuitionPlan: false,
            lastClassStudentId: null,
            CONFIG,
            disabled: false,
            PAYMENT_PLANS: CONFIG.PAYMENT_PLAN_IDS,
            STATUS_DISPLAY: CONFIG.TUITION_PAYMENT_STATUS.STATUS_DISPLAY,
            currency: this.$store.state.setting.currency || '',
        };
    },

    methods: {
        showStatementList() {
            this.$router.push({
                path: "/student/statement/list"
            });
        },

        resetStatementData() {
            this.statementInfo = {};
            this.attendedAcdYears = '';
            this.lastClassStudentId = null;
            this.ferryPayments = [];
            this.lateFees = [];
            this.tuitionBalanceSummary = {};
            this.allPaymentSummary = [];
            this.periodColumnName = '';
        },

        loadStatementDetail() {
            this.isLoading = true;
            this.resetStatementData();
            this.getStudentData();
        },

        /**
         * get tuition payment & student data
         */
        getStudentData() {
            axios.get(`student/statement/detail/${this.$route.params.tuitionPaymentId}`)
                .then(response => {
                    const info = response.data?.statement_info;
                    if (!info || info.id == null) {
                        this.resetStatementData();
                        this.isLoading = false;
                        return;
                    }
                    this.statementInfo = info;
                    this.attendedAcdYears = response.data.attended_acd_years;
                    this.lastClassStudentId = response.data.last_class_student_id;
                    this.setPeroidColumnHeader(this.statementInfo.payment_plan);
                    this.getFerryPayments();
                    this.getLateFees();
                    this.getTuitionBalanceSummary();
                    this.getAllPaymentSummary();
                })
                .catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    console.error("Error fetching student info:", error);
                    this.resetStatementData();
                    this.isLoading = false;
                });
        },

        /**
         * Get Period Column Header for tuition plan table
         * @param {int} paymentPlan 
         */
        setPeroidColumnHeader(paymentPlan) {
            switch (paymentPlan) {
                case 1:
                    this.periodColumnName = "Academic Year";
                    break;
                case 2: 
                    this.periodColumnName = "Term";
                    break;
                case 3: 
                    this.periodColumnName = "Month";
                    break;
            }
        },

        getPaymentPlanLabel(paymentPlan) {
            const PAYMENT_PLAN_LABELS_BY_ID = Object.fromEntries(
                Object.entries(CONFIG.PAYMENT_PLAN_IDS).map(([key, id]) => [
                    id,
                    key.charAt(0) + key.slice(1).toLowerCase(),
                ])
            );
            return PAYMENT_PLAN_LABELS_BY_ID[Number(paymentPlan)] ?? '';
        },

        /**
         * 
         */
        getFerryPayments() {
            axios.get(`student/statement/ferry-payments/${this.$route.params.tuitionPaymentId}`)
                .then(response => {
                    this.ferryPayments = response.data.ferry_payments;
                    this.isLoading = false;
                })
                .catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                    console.error("Error fetching ferry payments:", error);
                    this.isLoading = false;
                });
        },

        /**
         * Get Late Fees
         */
        getLateFees() {
            axios.get(`student/statement/late-fees/${this.$route.params.tuitionPaymentId}`)
                .then(response => {
                    this.lateFees = response.data.late_fees;
                })
                .catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                    console.error("Error fetching late fees:", error);
                });
        },

        /**
         * Get unpaid tuition balance summary
         */
        getTuitionBalanceSummary() {
            axios.get(`student/statement/tuition-balance/${this.$route.params.tuitionPaymentId}`)
                .then(response => {
                    this.tuitionBalanceSummary = response.data.summary;
                })
                .catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                    console.error("Error fetching tuition balance summary:", error);
                });
        },

        /**
         * Get all payment summary
         */
        getAllPaymentSummary() {
            axios.get(`student/statement/all-payment-summary/${this.$route.params.tuitionPaymentId}`)
                .then(response => {
                    this.allPaymentSummary = response.data.all_payment_summary;
                })
                .catch(error => {
                    if (error.response && error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                    console.error("Error fetching all payment summary:", error);
                });
        },

        /**
         * 
         * @param {Date} date 
         * @returns 
         */
        formatDate(date) {
            if (!date || !moment(date).isValid()) {
                return '';
            }
            return moment(date).format('DD MMM YYYY');
        },

        /**
         * Format amount with comma separation and no decimals
         * @param {Number|String} value 
         * @returns {String}
         */
        formatAmount(value) {
            if (value === null || value === undefined) return '0';
            let num = Number(String(value).replace(/,/g, ''));
            if (isNaN(num)) return value;
            return Math.round(num).toLocaleString('en-US') + this.currency;
        },

        /**
         * Redirect to enrollment payment create form
         */
        showEnrollmentEditForm(classStudentId) {
          this.$router.push({
                name: "enrollmentPaymentEdit",
                params: {
                    tuitionPaymentId: this.$route.params.tuitionPaymentId,
                    classStudentId: classStudentId,
                },
            });
        },

        /**
         * hide edit button according to payment statuses
         */
        showEditButton() {
          // Edit button will be allowed for those payments which have no approved history.
          return !this.statementInfo?.has_approved_payment_history;
        },

        /**
         * Redirect to tuition payment detail page
         */
        showTuitionPaymentDetail(id) {
            this.$router.push({
                name: "tuitionPaymentDetail",
                params: {
                    studentPaymentId: id,
                    tuitionPaymentId: this.$route.params.tuitionPaymentId
                }
            })
        },

        /**
         * Redirect to tuition payment edit page
         */
        showTuitionPaymentEdit(id) {
            this.$router.push({
                name: "tuitionPaymentEdit",
                params: {
                    studentPaymentId: id,
                    tuitionPaymentId: this.$route.params.tuitionPaymentId
                }
            })
        },
        
        /**
         * Redirect to Generate Ferry Payment page
         */
        generateFerryPlan(classStudentId) {
            if (!classStudentId) {
                this.$notification.error("Need to set result for the previous class to generate ferry payment for current statement.", {
                    timer: 3,
                    position: "bottomCenter"
                });
                return;
            }
            this.$router.push({
                name: "generateFerryPayment",
                params: {
                    tuitionPaymentId: this.$route.params.tuitionPaymentId,
                    classStudentId: classStudentId,
                },
            });
        },

        /**
         * Download tuition payment plan
         */
        downloadTuitionPaymentPlan() {
            this.isLoading = true;
            var request = {
                responseType: 'blob'
            }
            axios.get("/student/statement/download-tuition-plan/" + this.$route.params.tuitionPaymentId, request, {
                headers: {
                    'Content-Type': 'application/pdf',
                }
            })
            .then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                let date = new Date();
                // student_name_current_yyyy_mm_dd_tuition_plan.pdf
                const studentName = this.statementInfo.student_name || 'student';
                const prefix = this.statementInfo.has_pre_registration ? '_pre_registration_' : '_current_';
                const fileName = `${studentName}${prefix}${date.getFullYear()}_${(date.getMonth() + 1).toString().padStart(2, '0')}_${date.getDate().toString().padStart(2, '0')}_tuition_plan.pdf`;
                fileLink.setAttribute('download', fileName);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.isLoading = false;
            }).catch(error => {
                if (error.response && error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                this.isLoading = false;
                console.error("Download failed:", error);
            });
        },
        redirectDetailPage(payment) {
          if (payment.is_refund) {
            this.$router.push({
              name: "refundHistoryDetail",
              params: {
                id: payment.id
              }
            })
          } else if (payment.tuition_payment_id) {
            this.$router.push({
              name: "tuitionPaymentDetail",
              params: {
                studentPaymentId: payment.id,
                tuitionPaymentId: this.$route.params.tuitionPaymentId
              }
            })
          } else {
            this.$router.push({
              name: "paymentDetail",
              params: {
                invoiceId: payment.id
              }
            })
          }
        },

      goRefundPage() {
        const tuitionPaymentId = this.$route.params.tuitionPaymentId;
        this.$router.push({
          name: 'tuitionPaymentRefundConfirm',
          params: {
            tuitionPaymentId: tuitionPaymentId
          }
        })
      },

      allPaymentsFullyPaid() {
        const payments = this.statementInfo?.student_payments || [];
        if (payments.length === 0) return false;
        return payments.every(p => p.payment_history_status === CONFIG.PARENT_PAYMENT_STATUS.FULLY_PAID);
      }
    },

    computed: {
        hasStatementData() {
            return this.statementInfo && Object.keys(this.statementInfo).length !== 0;
        },
        hasEditablePayment() {
            const payments = this.statementInfo?.student_payments || [];
            if (payments.length === 0) return false;
            return payments[0].payment_history_status !== CONFIG.PARENT_PAYMENT_STATUS.FULLY_PAID;
        },
        tuitionTableColspan() {
            return this.hasEditablePayment ? 6 : 5;
        }
    },

    watch: {
        '$route.params.tuitionPaymentId'(newId, oldId) {
            if (newId && newId !== oldId) {
                this.loadStatementDetail();
            }
        },
    },

    mounted() {
        this.loadStatementDetail();
    }
};
